<template>
    <ul class="policies">
        <li class="policies__policy">
            <a ref="terms"
               href="#"
               class="policies__policy__link policies__policy__link--terms"
               @click="onTermsClick">Terms &amp; Conditions</a>
        </li>
        <li class="policies__policy">
            <a ref="privacy"
               href="#"
               class="policies__policy__link policies__policy__link--privacy"
               @click="onPrivacyPolicyClick">Privacy</a>
        </li>
        <li class="policies__policy">
            <a ref="cookies"
               href="#"
               class="policies__policy__link policies__policy__link--cookies"
               @click="onCookiesPolicyClick">Cookies</a>
        </li>
    </ul>
</template>

<script>

import PolicyPresenter from '../copy/policy-presenter'
import Policies from '../copy'

export default {

    props: {
        handleEventsExternally: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        PolicyPresenter,
    ],

    methods: {

        onCookiesPolicyClick($event) {
            this.onPolicyClick($event, Policies.Cookies, 'Cookies & Local Data Policy', this.$refs.cookies)
        },

        onPrivacyPolicyClick($event) {
            this.onPolicyClick($event, Policies.Privacy, 'Privacy Notice', this.$refs.privacy)
        },

        onTermsClick($event) {
            this.onPolicyClick($event, Policies.TermsAndConditions, 'Terms & Conditions', this.$refs.terms)
        },

        onPolicyClick($event, policy, title, refocusRef) {
            this.$eventbus.$off(this.$appevents.afterModalClose)
            this.$eventbus.$on(this.$appevents.afterModalClose, () => {
                this.$logger.logObject({ ref: refocusRef }, 'Post close action', 'Modal')
                refocusRef.focus()
            })
            if (this.handleEventsExternally) {
                $event.linkType = 'modal'
                $event.linkTarget = 'app'
                $event.action = () => {
                    this.showPolicy(policy, title, {
                        onClose: () => history.go(-2),
                    })
                }
                this.$emit('click', $event)
            } else {
                this.showPolicy(policy, title)
            }
        },
    },
}

</script>


<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\app-core\_app-policies.scss

.policies {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    @include bp-min-small {
        display: block;
    }

    @include element('policy') {
        display: inline-block;
        padding: 0 $base-gutter;

        &:last-child {
            padding-right: 0;
        }

        @include element('link') {
            white-space: nowrap;
        }
    }
}

</style>
